<template>
  <section
    v-if="
      route.name !== 'EventFilter' &&
        route.name !== 'FestivalFilter' &&
        event.id &&
        event.enabled &&
        event.tickets_enabled &&
        (event.ticket_types_count > 0 || event.options?.length > 0)
    "
    class="lg:hidden mobile-banner flex flex-col gap-4 justify-center items-center"
    :class="{
      'small-ad': displayed_smartIntxt,
      'big-ad': displayed_sc_top,
      'medium-ad': displayed_sc_top_medium,
      'bigger-ad': displayed_sc_top_big,
      'video-ad': displayed_sc_top_video
    }"
  >
    <w-navigation
      v-if="!isExternal"
      :params="{
        name: 'PurchasePage',
        params: {
          slug: event.slug
        },
        ...referenceQuery
      }"
      :full="false"
    >
      <template #link>
        <wegow-button
          button-id="square-banner"
          background="opacity"
          color="topaz-light"
          type="button"
          :text="$t('wegow.purchase.buy')"
          :sub-text="`${$t('profiles.from')} ${priceFormatted}`"
        />
      </template>
    </w-navigation>
    <a v-else-if="event.options.length === 1" :href="event.options[0].url">
      <wegow-button
        button-id="square-banner"
        background="opacity"
        color="topaz-light"
        type="button"
        :text="$t('wegow.purchase.buy')"
        :sub-text="`${$t('profiles.from')} ${priceFormatted}`"
      />
    </a>
    <wegow-button
      v-else
      button-id="square-banner"
      background="opacity"
      color="topaz-light"
      type="button"
      :text="$t('wegow.purchase.buy')"
      :sub-text="`${$t('profiles.from')} ${priceFormatted}`"
      @click="scrollToNav"
    />
    <div class="w-full right-0 flex justify-center cursor-pointer gap-2">
      <!-- <icon
        :size="30"
        :img="
          event.user.tracking
            ? require('@/assets/images/ic-full-heart-rounded-topaz.svg')
            : require('@/assets/images/ic-heart-topaz.svg')
        "
        @click="
          isAuth ? interested(event) : openModal(SIGN_IN);
          sendGa('sign-in');
        "
      /> -->
      <icon
        class="interaction__btn transition-al"
        :img="
          event.user.tracking
            ? require('@/assets/images/ic-full-heart-rounded-topaz.svg')
            : require('@/assets/images/ic-empty-heart-rounded-topaz.svg')
        "
        :size="41"
        @click="
          isAuth ? interested(event) : openModal(SIGN_IN);
          sendGa('sign-in');
        "
      />
      <icon
        class="interaction__btn"
        :img="require('@/assets/images/ic-followers-circle-topaz.svg')"
        :size="41"
        @click="scrollToSection('followers')"
      />
      <span
        href="#"
        class="chat-button interaction__btn"
        @click="scrollToSection('chat-section')"
      >
        <icon
          :img="require('@/assets/images/ic-chat-circle-topaz.svg')"
          :size="41"
        />
      </span>
      <div
        class="share-button flex flex-col interaction__btn"
        @click="openShareModal()"
      >
        <icon
          :img="require('@/assets/images/ic-share-circle-topaz.svg')"
          :size="41"
        />
      </div>
    </div>
  </section>
  <Suspense>
    <template #default>
      <ShareModal
        v-if="openShareVar"
        category="event"
        @close="openShareVar = false"
      ></ShareModal>
    </template>
    <template #fallback>
      <wegow-loader class="min-h-screen" />
    </template>
  </Suspense>
</template>

<script setup>
import { useEvent } from "@/composables/useEvent";

import WegowButton from "@/components/general/forms/WegowButton.vue";
import WNavigation from "@/components/general/ui/WNavigation";
import Icon from "@/components/general/ui/elements/WIcon.vue";
import WegowLoader from "@/components/general/ui/WegowLoader";

import {
  computed,
  onMounted,
  ref,
  defineAsyncComponent,
  onUnmounted
} from "vue";
import { useRoute } from "vue-router";
import { useModalHandler } from "@/plugins/useModalHandler";
import { formatCurrency } from "@/plugins/currency";
import { useUser } from "@/composables/useUser";

const ShareModal = defineAsyncComponent(() =>
  import("@/components/general/modals/ModalShare.vue")
);
const { details: event, followEvent, unfollowEvent, getDetails } = useEvent();
const { isAuth } = useUser();

const route = useRoute();
const { SIGN_IN, openModal } = useModalHandler();
const emit = defineEmits([
  "update:redirect-followers",
  "update:redirect-chat",
  "update:share-event"
]);

// const afterHeader = ref(false);
const displayed_sc_top = ref(false);
const displayed_sc_top_big = ref(false);
const displayed_smartIntxt = ref(false);
const displayed_sc_top_medium = ref(false);
const displayed_sc_top_video = ref(false);
const openShareVar = ref(false);
const observer = ref(null);

onMounted(async () => {
  const targetNode = document.body; // Observar el body en caso de que el elemento se agregue dinámicamente
  const config = { childList: true, subtree: true, attributes: true };
  observer.value = new MutationObserver(() => {
    handleBannerMargin();
  });
  observer.value.observe(targetNode, config);
  handleBannerMargin();
});

onUnmounted(() => {
  if (observer.value) observer.value.disconnect();
});

const isExternal = computed(() => {
  return event.value.has_options && event.value.options.length > 0;
});
const priceFormatted = computed(
  () =>
    formatCurrency(Number(event.value.price).toFixed(2), event.value.currency)
  // TODO: revisar si es necesario el fixed y el number
);

const referenceQuery = computed(() => {
  let reference = {};
  if (route.query.r) {
    reference.query = { r: route.query.r };
  }
  if (route.hash) {
    reference.hash = route.hash;
  }
  return reference;
});

const goToLinks = () => {
  let elemento = document.getElementById("info-external-links");
  let offset = 250; // Espacio adicional en la parte superior

  let elementoPosicion = elemento.getBoundingClientRect().top;
  let scrollPosicion = window.pageYOffset || document.documentElement.scrollTop;

  let posicionFinal = elementoPosicion + scrollPosicion - offset;

  window.scrollTo({
    top: posicionFinal,
    behavior: "smooth"
  });
};
const interested = async event => {
  if (event.user.tracking) {
    await unfollowEvent(event);
  } else {
    await followEvent(event);
  }
  await getDetails(route.params.slug);
};
const sendGa = label => {
  // if (this.$gtag && typeof this.$gtag.event === "function")
  //   this.$gtag.event("click", {
  //     event_category: label
  //   });
};

const openShareModal = () => {
  openShareVar.value = !openShareVar.value;
};

const scrollToNav = event => {
  const scrollAncle = document.getElementById("event-nav");
  if (scrollAncle) {
    scrollAncle.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};

const handleBannerMargin = () => {
  let itemST = document.getElementById("sc-top");
  if (itemST) {
    if (itemST.style.display === "none") {
      displayed_sc_top.value = false;
      displayed_sc_top_big.value = false;
      displayed_sc_top_medium.value = false;
      displayed_sc_top_video.value = false;
    } else {
      let classes = itemST.classList;
      if (classes.contains("sc_expanded")) {
        displayed_sc_top.value = false;
        displayed_sc_top_big.value = true;
        displayed_sc_top_medium.value = false;
        displayed_sc_top_video.value = false;
      } else if (classes.contains("sc_catalogueAd")) {
        displayed_sc_top.value = false;
        displayed_sc_top_big.value = false;
        displayed_sc_top_medium.value = true;
        displayed_sc_top_video.value = false;
      } else if (classes.contains("sc_stickyscroller_3_0")) {
        displayed_sc_top.value = false;
        displayed_sc_top_big.value = false;
        displayed_sc_top_medium.value = false;
        if (classes.contains("sc_sticky_changDir")) {
          displayed_sc_top_video.value = true;
        } else {
          displayed_sc_top_video.value = false;
        }
      } else if (
        itemST.dataset.googleQueryId ||
        itemST.querySelector("script") !== null
      ) {
        displayed_sc_top.value = true;
        displayed_sc_top_big.value = false;
        displayed_sc_top_medium.value = false;
        displayed_sc_top_video.value = false;
      }
    }
  } else {
    displayed_sc_top.value = false;
    displayed_sc_top_big.value = false;
    displayed_sc_top_medium.value = false;
    displayed_sc_top_video.value = false;
  }

  let itemSI = document.getElementById("smartIntxt");
  if (itemSI) {
    let newItem = itemSI.getElementsByTagName("iframe");
    if (newItem.length > 0) {
      displayed_smartIntxt.value = true;
    } else {
      displayed_smartIntxt.value = false;
    }
  } else {
    displayed_smartIntxt.value = false;
  }
};
const scrollToSection = id => {
  const element = document.getElementById(id);
  window.scrollTo({
    top: element.offsetTop,
    behavior: "smooth"
  });
};
</script>

<style lang="scss" scoped>
.mobile-banner {
  position: fixed;
  background-color: $backgroundBlackOpacity5;
  background: linear-gradient(
    180deg,
    rgba(181, 181, 181, 0) 0%,
    rgba(0, 0, 0, 1) 100%
  );
  bottom: 0px;
  width: 100%;
  height: 160px;
  z-index: 100001 !important; // Para que siempre esté por encima del anuncio pase lo que pase
  &.small-ad {
    bottom: 118px;
  }
  &.big-ad {
    bottom: 125px;
  }
  &.medium-ad {
    bottom: 175px;
  }
  &.bigger-ad {
    bottom: 225px;
  }
  &.video-ad {
    bottom: 250px;
  }
}
</style>
